import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useHistory } from 'react-router-dom'
import { tabsItems } from './constants/tabsItems.constant'
import UpdateEmployeeForm from './feature/BusinessCardOrderForm/UpdateEmployeeForm'
import {
  useBusinessCardOrderDetailMutation,
  useBusinessCardQhtStatusQuery,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'
import ContentBoxNew from '@shared/ContentBoxNew'

export default function UpdateBusinessCardOrder() {
  const { t } = useTranslation()
  const orderNo = useParams<{ orderNo: string }>()?.id
  const {
    isError: isQhtError,
    isSuccess: isQhtSuccess,
    isFetching: isQhtFetching,
    isLoading: isQhtLoading,
    error: qhtError,
  } = useBusinessCardQhtStatusQuery({ status: 'frozen', page: 'update' })

  const history = useHistory()
  function handleClick() {
    history.push('/orders/business-card')
  }

  const [
    fetchOrderDetail,
    {
      isLoading: isOrderDetailLoading,
      isError: isOrderDetailError,
      isSuccess: isOrderDetailSuccess,
      error: orderDetailError,
    },
  ] = useBusinessCardOrderDetailMutation({
    fixedCacheKey: 'businessCardOrderDetail',
  })

  useEffect(() => {
    if (orderNo) {
      fetchOrderDetail({ orderNo })
    }
  }, [fetchOrderDetail, orderNo])

  const isLoading = isQhtFetching || isOrderDetailLoading || isQhtLoading

  const isError =
    isQhtError || isOrderDetailError || !isQhtSuccess || !isOrderDetailSuccess

  const getErrorMessage = () => {
    if (isQhtError && qhtError?.data) {
      return qhtError.data
    }
    if (isOrderDetailError && orderDetailError?.data) {
      return orderDetailError.data
    }
    return 'Xəta baş verdi'
  }

  const shouldRenderChildren =
    isQhtSuccess && isOrderDetailSuccess && !isLoading && !isError

  return (
    <ContentBoxNew
      activeKey="item-3"
      items={[
        ...tabsItems(),
        {
          label: t('transfers.edit'),
          key: 'item-3',
          path: '/orders/business-card/update',
        },
      ]}
      isLoading={isLoading}
      isError={isError}
      errorMessage={getErrorMessage()}
      handleClick={handleClick}
      title={t('businessCardOrders.businessCardOrders')}
      shouldRenderChildren={shouldRenderChildren}
    >
      <UpdateEmployeeForm />
    </ContentBoxNew>
  )
}
